export default __webpack_public_path__ + "media/images/main/arrow-blue2-31c796990587d33d8c7bfc494c2f59de.png";